import { watchFetchUnallocatedProducts } from './fetchUnallocatedProducts';

export const unallocatedProductsSagas = [watchFetchUnallocatedProducts()];
